import React from 'react';
import './SignatureUpdatePage.scss';
import { CustomBottomBar } from '@components';
import { Button, Container, Modal, Spacing, Typography } from '@design-system';
import SignatureCanvas from 'react-signature-canvas';
import { useSignatureUpdatePageVM } from './useSignatureUpdatePageVM';
import { RiArrowGoBackLine } from 'react-icons/ri';
import { MdKeyboardArrowRight } from 'react-icons/md';
import { IoMdClose } from 'react-icons/io';
import { formatDate } from '@utils';

export const SignatureUpdatePage: React.FC = () => {
    const {
        signatureCanvasRef,
        handleClearSignature,
        isEmpty,
        setIsEmpty,
        previousSignature,
        showConfirmationModal,
        setShowConfirmationModal,
        handleConfirmSave
    } = useSignatureUpdatePageVM();

    return (
        <>
            <Container className="signature-update-page">
                <Container bordered="grey" center column padding="medium" className="previous-signature-container">
                    <div className="previous-signature-content">
                        <div className="previous-signature-image-container">
                            {previousSignature ? (
                                <img src={previousSignature.signature} alt="Signature actuelle" className="previous-signature-image" />
                            ) : (
                                <div className="no-signature">
                                    <Typography intrinsic="p" variant="secondary" color="grey">
                                        Aucune signature
                                    </Typography>
                                </div>
                            )}
                        </div>
                        <div className="previous-signature-text">
                            <Typography intrinsic="h3" color="marine">
                                Ma signature
                            </Typography>
                            {previousSignature && (
                                <Typography intrinsic="p" variant="secondary" color="grey" className="mt-small-spacing">
                                    Créée le {formatDate(previousSignature.signature_updated_at)}
                                </Typography>
                            )}
                        </div>
                    </div>
                </Container>

                <Container bordered="grey" center column padding="medium" className="signature-container">
                    <Typography intrinsic="h4" className="signature-title">
                        Modifier votre signature
                    </Typography>
                    <Typography intrinsic="p" variant="secondary" color="grey" className="mt-small-spacing">
                        Votre signature sera utilisée pour valider des documents internes. Prenez un moment pour dessiner une signature
                        claire et précise.
                    </Typography>

                    <Container padding="none" className="signature-grow">
                        <SignatureCanvas
                            throttle={24}
                            velocityFilterWeight={1}
                            penColor="black"
                            canvasProps={{
                                className: 'sigCanvas'
                            }}
                            onEnd={() => setIsEmpty(false)}
                            ref={signatureCanvasRef}
                        />
                        <Spacing />
                        <div className="buttons">
                            <Button
                                icon={<RiArrowGoBackLine />}
                                iconSize={25}
                                onClick={handleClearSignature}
                                iconColor="green"
                                variant="secondary"
                                color="green"
                                className="refresh-signature-button"
                            >
                                <></>
                            </Button>
                        </div>
                    </Container>
                </Container>
            </Container>
            <CustomBottomBar>
                <Button
                    onClick={() => setShowConfirmationModal(true)}
                    color="marine"
                    size="fullwidth"
                    icon={<MdKeyboardArrowRight />}
                    iconPosition="forced-right"
                    iconColor="white"
                    iconSize={25}
                    disabled={isEmpty}
                >
                    <Typography intrinsic="h4">Mettre à jour</Typography>
                </Button>
            </CustomBottomBar>

            <Modal
                title="Confirmation"
                open={showConfirmationModal}
                setClose={() => setShowConfirmationModal(false)}
                className="signature-confirmation-modal"
                footer={
                    <div className="modal-footer">
                        <Button
                            color="grey"
                            variant="tertiary"
                            onClick={() => setShowConfirmationModal(false)}
                            icon={<IoMdClose />}
                            iconPosition="right"
                            iconSize={20}
                        >
                            <Typography intrinsic="h4">Annuler</Typography>
                        </Button>
                        <Button color="green" size="small" variant="secondary" onClick={handleConfirmSave}>
                            <Typography intrinsic="h4">Valider</Typography>
                        </Button>
                    </div>
                }
            >
                <Container padding="medium" className="modal-text-container">
                    <Typography intrinsic="p" variant="secondary">
                        En appuyant sur "valider", vous acceptez que cette nouvelle signature remplace l'ancienne et soit apposée sur tous
                        les documents la nécessitant.
                    </Typography>
                </Container>
            </Modal>
        </>
    );
};
